<template>
    <div class="message-list">
        <message-group  v-for="messageGroup in messageGroups" :key="'gr_' + messageGroup.id" :message-group="messageGroup"></message-group>
    </div>
</template>

<script>
import MessageGroup from "./MessageGroup";
import Events from "../../events";
export default {
    name: "MessageGroups",
	components:{
		MessageGroup
	},
    props:{
        requisitionId:{
            type: Number,
            default: 0
        }
    },
    data() {
        return {
            messageGroups:[],
        }
    },
    mounted() {
        this.loadMessageGroups();
		Events.addEventListener("reload-messages", this.loadMessageGroups);
    },
    methods: {
        loadMessageGroups(){
            if(this.requisitionId > 0){
                axios.get("/api/messages/get/requisition/" + this.requisitionId).then(
                    (pack) => this.loadedMessageGroups(pack),
                    (pack) => this.loadMessageFailure(pack),
                );
            } else {
                axios.get("/api/messages/get/user").then(
                    (pack) => this.loadedMessageGroups(pack),
                    (pack) => this.loadMessageFailure(pack),
                );
            }
        },
        loadedMessageGroups(pack){
            if(pack.data.success){
                this.messageGroups = pack.data.data;
            }
        },
        loadMessageFailure(pack){

        },
    },
	watch:{
		messageGroups: {
			handler: function (val) {
				//the function just has to exist, only want the deep setting
				this.$forceUpdate();
			},
			deep: true
		}
	}
}
</script>
